import { render, staticRenderFns } from "./sidebarGroup.vue?vue&type=template&id=12bb0c32"
import script from "./sidebarGroup.vue?vue&type=script&lang=js"
export * from "./sidebarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports